<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#005f32"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showsnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex>
        <v-card-title class="elevation-0">
          <span class="itemHeading">LOCATIONS</span>
          <v-spacer></v-spacer>
          <v-flex xs6 sm6 md6 text-right>
            <v-btn
              color="#005f32"
              dark
              outlined
              @click="dialogAdd = true"
              rounded
              >Add New</v-btn
            >
          </v-flex>
        </v-card-title>
        <v-layout wrap justify-start pa-5 v-if="locationList.length > 0">
          <v-flex xs12>
            <v-simple-table class="align-center">
              <template v-slot:default>
                <thead style="background-color: #005f32">
                  <tr>
                    <th
                      style="
                        width: 100%;
                        font-size: 15px;
                        color: #ffffff;
                        font-family: kumbhRegular;
                      "
                      class="text-left"
                    >
                      Location Name
                    </th>
                    <th
                      style="
                        font-size: 15px;
                        color: #ffffff;
                        font-family: kumbhRegular;
                        white-space: nowrap;
                      "
                      class="text-right"
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody class="align-center">
                  <tr
                    class="text-left align-center"
                    v-for="(item, i) in locationList"
                    :key="i"
                  >
                    <td>
                      <span class="" style="font-family: kumbhMedium">{{
                        item.name
                      }}</span>
                    </td>
                    <td class="text-right" style="white-space: nowrap">
                      <v-icon
                        @click="(dialogEdit = true), (editItem = { ...item })"
                        title="Edit"
                        color="#005f32"
                        >mdi-pencil</v-icon
                      >
                      <v-icon
                        @click="(dialogDelete = true), (deleteTarget = item)"
                        title="Delete"
                        color="red"
                        class="ml-3"
                        >mdi-delete</v-icon
                      >
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-flex>
        </v-layout>
        <v-layout wrap v-else>
          <v-flex xs12 align-self-center pa-16>
            <span class="kumbhRegular">No Data found!</span>
          </v-flex>
        </v-layout>
        <v-dialog persistent v-model="dialogAdd" max-width="50%">
          <v-card tile>
            <v-card-title>
              <span class="itemHeading">Location</span>
            </v-card-title>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12 sm12 pt-5 px-5 text-left>
                  <span class="itemText2">Please Enter the Location Name *</span>
                  <v-text-field
                    outlined
                    dense
                    v-model="locationName"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="(dialogAdd = false), (locationName = '')"
              >
                Close
              </v-btn>
              <v-btn color="blue darken-1" text @click="add()"> Save </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog persistent v-model="dialogEdit" max-width="50%">
          <v-card tile>
            <v-card-title>
              <span class="itemHeading">Location</span>
            </v-card-title>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12 sm12 pt-5 px-5 text-left>
                  <span class="itemText2">Please Enter the Location Name *</span>
                  <v-text-field
                    outlined
                    dense
                    v-model="editItem.name"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogEdit = false">
                Close
              </v-btn>
              <v-btn color="blue darken-1" text @click="edit()">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog persistent v-model="dialogDelete" max-width="600px">
          <v-card tile>
            <v-layout wrap>
              <v-flex
                xs12
                align-self-center
                pa-4
                style="background: #005f32"
                text-left
              >
                <span class="kumbhBold" style="color: #ffffff"
                  >Delete Confirmation</span
                >
              </v-flex>
            </v-layout>
            <v-card-title
              >Are you sure you want to delete this
              Location?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" tile dark @click="dialogDelete = false"
                >Cancel</v-btn
              >
              <v-btn
                color="#005f32"
                outlined
                tile
                @click="confirmDelete()"
                >Delete</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center v-if="pages > 1">
      <v-flex align-self-center>
        <div class="pt-2">
          <v-pagination
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            :length="pages"
            :total-visible="7"
            v-model="currentPage"
            color="#005f32"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    showsnackbar: false,
    ServerError: false,
    msg: null,
    appLoading: false,
    locationList: [],
    locationName: "",
    editItem: {},
    deleteTarget: null,
    dialogAdd: false,
    dialogEdit: false,
    dialogDelete: false,
    currentPage: 1,
    limit: 10,
    pages: 0,
    totalData: 0,
  }),
  watch: {
    currentPage() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        url: "/organisation/locations/list",
        method: "POST",
        data: {
          page: this.currentPage,
          limit: this.limit,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.locationList = response.data.data;
          this.totalData = response.data.length;
          this.pages = Math.ceil(this.totalData / this.limit);
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    add() {
      if (!this.locationName) {
        this.msg = "Please enter a location name";
        this.showsnackbar = true;
        return;
      }
      axios({
        method: "POST",
        url: "/organisation/locations/add",
        data: {
          name: this.locationName,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.dialogAdd = false;
            this.locationName = "";
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.status === false) {
            this.msg = "Please Try Again";
            this.showsnackbar = true;
          }
        });
    },
    edit() {
      axios({
        method: "POST",
        url: "/organisation/locations/edit/" + this.editItem._id,
        data: {
          name: this.editItem.name,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.dialogEdit = false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.status === false) {
            this.msg = "Please Try Again";
            this.showsnackbar = true;
          }
        });
    },
    confirmDelete() {
      axios({
        method: "POST",
        url: "/organisation/locations/remove/" + this.deleteTarget._id,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.dialogDelete = false;
          if (response.data.status === true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.dialogDelete = false;
          if (err.response && err.response.data && err.response.data.status === false) {
            this.msg = "Please Try Again";
            this.showsnackbar = true;
          }
        });
    },
  },
};
</script>
<style>
.tableHead {
  font-size: 15px;
  color: #ffffff;
  font-family: kumbhMedium;
}
</style>
